<aside class="main-sidebar sidebar-dark-primary elevation-4">
  <a href="index3.html" class="brand-link" *ngIf="show==false">
    <img src="assets/img/logo.webp" alt="Momentum India Logo" class="brand-image " style="opacity: 1">
  </a>
  <a href="index3.html" class="brand-link" *ngIf="show==true">
    <img src="assets/img/logo.webp" alt="Momentum India Logo" class="brand-image-nav " style="opacity: 1">
  </a>
  <div class="sidebar">
    <nav class="mt-2">
      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">

        <li class="nav-item" *ngIf="usertype =='superadmin'">
          <a [routerLink]="['/dashboard']" class="nav-link" [ngClass]="{'active': currentUrl=='/dashboard'}">
            <i class="fas fa-chart-bar nav-icon"></i>
            <p>Attendees-Dashboard</p>
          </a>
        </li>
        <li class="nav-item" *ngIf="usertype =='superadmin'">
          <a [routerLink]="['/event']" class="nav-link" [ngClass]="{'active': currentUrl=='/event'}">
            <i class="fas fa-city nav-icon"></i>
            <p>Event</p>
          </a>
        </li>
        <li class="nav-item" *ngIf="usertype =='superadmin' || usertype =='orgadmin' || usertype =='plantsadmin'">
          <a [routerLink]="['/gate']" class="nav-link" [ngClass]="{'active': currentUrl=='/gate'}">
            <i class="nav-icon fas fa-door-open"></i>
            <p>Gate</p>
          </a>
        </li>
        <li class="nav-item" *ngIf="usertype =='superadmin' || usertype =='orgadmin' || usertype =='plantsadmin'">
          <a [routerLink]="['/user']" class="nav-link" [ngClass]="{'active': currentUrl=='/user'}">
            <i class="nav-icon fas fa-users"></i>
            <p>Attendees</p>
          </a>
        </li>

        <li class="nav-item" *ngIf="usertype =='superadmin' || usertype =='orgadmin' || usertype =='plantsadmin'">
          <a [routerLink]="['/assign-role']" class="nav-link" [ngClass]="{'active': currentUrl=='/assign-role'}">
            <i class="nav-icon fas fa-user"></i>
            <p>Assign Role</p>
          </a>
        </li>
        <li class="nav-item" *ngIf="usertype =='superadmin' || usertype =='orgadmin' || usertype =='plantsadmin'">
          <a [routerLink]="['/rich-text-editor']" class="nav-link"
            [ngClass]="{'active': currentUrl=='/rich-text-editor'}">
            <i class="nav-icon fas  fa-comment-alt"></i>
            <p>Text</p>
          </a>
        </li>
        <li class="nav-item" *ngIf="usertype =='superadmin' || usertype =='orgadmin' || usertype =='plantsadmin'">
          <a [routerLink]="['/about']" class="nav-link" [ngClass]="{'active': currentUrl=='/about'}">
            <i class="nav-icon fas fa-info-circle"></i>
            <p>About Us</p>
          </a>
        </li>
        <li class="nav-item" *ngIf="usertype =='superadmin' || usertype =='orgadmin' || usertype =='plantsadmin'">
          <a [routerLink]="['/dining-time']" class="nav-link" [ngClass]="{'active': currentUrl=='/dining-time'}">
            <i class="nav-icon fas fa-hourglass-half"></i>
            <p>Time</p>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</aside>